var React = require('react');

function IconShoppingCart (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(.75 .75)","fill":"none","stroke":"#fff","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","strokeWidth":"1.5"},[React.createElement("path",{"d":"M5.576 6.576h18.271L19.99 17.031a.975.975 0 01-.914.711H7.5a1.079 1.079 0 01-1.015-.914L4.56 1.5H.5","transform":"translate(-.5 -1.5)","key":0}),React.createElement("circle",{"cx":"2","cy":"2","r":"2","transform":"translate(15.806 19.167)","key":1}),React.createElement("circle",{"cx":"2","cy":"2","r":"2","transform":"translate(4.806 19.167)","key":2})]));
}

IconShoppingCart.defaultProps = {"className":"icon-shopping-cart","width":"24.847","height":"24.667","preserveAspectRatio":"xMidYMid meet"};

module.exports = IconShoppingCart;

IconShoppingCart.default = IconShoppingCart;
